<style scoped>
.form-title {
  font-size: 18px;
  text-align: center;
  padding: 3px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
</style>

<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div class="form-title">Property</div>
          <vue-form-generator
            :schema="schemas.property.schema"
            :options="schemas.property.formOptions"
            :model="model"
            ref="propertyForm"
          >
          </vue-form-generator>
        </b-col>
      </b-row>
      <b-row v-if="model.loan">
        <b-col>
          <div class="form-title">Mortgage</div>
          <vue-form-generator
            :schema="schemas.mortgage.schema"
            :options="schemas.mortgage.formOptions"
            :model="model"
            ref="mortgageForm"
          >
          </vue-form-generator>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-auto ml-auto">
          <add-asset-button
            id="extra-asset-real-state"
            style-class-row="pr-3"
            @submit="submitForm"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import AddAssetButton from '@/components/utils/buttons/misc/AddAssetButton';
import ASSET_SCHEMAS from '@/components/profile/sections/tabs/financial/assets/schemas/';


export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    AddAssetButton,
  },
  props: {
    model: Object,
  },
  data() {
    return {
      schemas: ASSET_SCHEMAS.real_estate,
    };
  },
  methods: {
    submitForm(extraItem) {
      const model = this.model;
      const isPropertyValid = this.$refs.propertyForm.validate();
      const isMortgageValid = model && model.loan ? this.$refs.mortgageForm.validate() : true;

      if (isPropertyValid && isMortgageValid) {
        this.$emit('on-submit', extraItem);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/financial/assets/RealEstateForm.vue